<template>
    <tr>
      <!-- title -->
      <td class="text-left ml-5">
        <router-link class="color-default" :to="'/event/' + event.slug">{{ event.title }}</router-link>
      </td>
      <td v-if="event.published == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <td v-if="event.featured == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <!-- controls [Update, Delete] -->
      <td>
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link class="dropdown-item" :to="'/event/edit/' + event.slug">Update</router-link>
          <template>
            <a class="dropdown-item" v-if="event.published == 0" @click="publishing('publish')">Publish</a>
            <a class="dropdown-item" v-else @click="publishing('unpublish')">Unpublish</a>
          </template>
          <a class="dropdown-item text-danger" @click="deleteEvent">Delete</a>
        </ul>
      </td>
    </tr>
  </template>
  
  <script>
    export default {
      name: "FAQRow",
      props: ["event", "pageNumber"],
      computed: {
        author: function () {
          if (typeof this.event.author === "undefined") {
            return "unknown";
          }
          return this.event.author.name;
        },
      },
      methods: {
        publishing(action) {
          this.$store
            .dispatch("events/publishing", {
              event: this.event,
              action: action,
            })
            .then((response) => { 
              if(response.data.data.published == 1) {
                this.$toast.success('Event published successfully!');
              } else {
                this.$toast.success('Event unpublished successfully!');
              }
             
            });
        },
        deleteEvent() {
          this.$store.dispatch("message/update", {
            title: this.event.title,
            body: "Are you sure you want to delete this Event?",
            class: "danger",
            confirm: true,
          });
  
          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.delete(this.event);
            this.$store.dispatch("message/close");
          });
        },
        delete(event) {
          this.$store.dispatch("events/delete", event)
            .then(() => {
              this.$parent.$parent.getEvents(this.pageNumber,'');
              this.$toast.success('Event deleted successfully!');
            })
            .catch((error) => {
              // send error message
              this.$toast.success(error.response.data.message);
            });
        },
      },
    };
  </script>
  <style scoped>
    table tr td:nth-child(1) {
      width: 35% !important;
      padding-left: 40px;
    }
  
    table tr td:nth-child(2) {
      width: 35% !important;
    }
  
    table tr td:nth-child(3) {
      width: 20% !important;
    }
  
    table tr td:nth-child(4) {
      width: 10% !important;
    }
  </style>